import {FirestoreService} from './FirestoreService';
import {Adjunct} from '../models';


export class AdjunctFirestoreService extends FirestoreService<Adjunct> {

  constructor(kwArgs: {
    equals?: {[key: string]: any}|null,
    orderBy?: string
  } = {}) {
    super({
      path: 'adjuncts',
      objectCreator: Adjunct,
      equals: kwArgs.equals,
      orderBy: kwArgs.orderBy
    });
    console.log('AdjunctService construct');
  }
}
